import { Flex, type StackProps } from '@chakra-ui/react';
import React from 'react';
import {
  type FieldValues,
  FormProvider,
  type SubmitHandler,
  type UseFormReturn,
} from 'react-hook-form';

interface FormProps<TFormValues extends FieldValues> {
  children: React.ReactNode;
  onSubmit: SubmitHandler<TFormValues>;
  childrenContainerProps?: StackProps;
  methods: UseFormReturn<TFormValues>;
  formId: string;
}

const Form = <TFormValues extends FieldValues>({
  children,
  onSubmit,
  childrenContainerProps = {},
  formId,
  methods,
}: FormProps<TFormValues>) => {
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <Flex
        as='form'
        flexDir='column'
        id={formId}
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        {...childrenContainerProps}
      >
        {children}
      </Flex>
    </FormProvider>
  );
};

export default Form;
